import commonStrings from "./common";
import termsStrings from "./terms";
import { GIFT_SUBSCRIPTIONS, SUBSCRIPTIONS } from "../constants";

export const constants = {
  APPLY_PROMO_CODE: "Apply Promotion Code",
  EXTEND_MGM_PROMO_SUB: "Extend BetMGM Promo Subscription",
  FORM_ABANDONMENT: "Form Abandonment",
  GIFT_SUBSCRIPTIONS,
  NEW_ANNUAL_SUB: "New Annual Subscription",
  NEW_MGM_PROMO_SUB: "New BetMGM Promo Subscription",
  NEW_MONTHLY_SUB: "New Monthly Subscription",
  SUBSCRIPTIONS
};

// TODO: https://griosf.atlassian.net/browse/RVLS-7859
export default {
  ...termsStrings,
  annualBullets: (siteName: string): string[] => [
    `One year subscription to ${siteName}`,
    "Billed each year"
  ],
  annualCostDescription: (annualCostDollars: string): string =>
    `$${annualCostDollars} / year`,
  annualSubscription: "Annual Subscription",
  cancel: commonStrings.cancel,
  monthlyBullets: (siteName: string): string[] => [
    `One month subscription to ${siteName}`,
    "Billed each month"
  ],
  monthlyCostDescription: (monthlyCostDollars: string): string =>
    `$${monthlyCostDollars} / month`,
  monthlySubscription: "Monthly Subscription",
  selectATeam: "Select a team",
  selectSitePrompt: "Please select a site before continuing.",
  subscribe: commonStrings.subscribe,
  upgrade: "Upgrade",
  vermontOptIn:
    "I understand and agree that my subscription will be automatically renewed on an annual basis at the then-current subscription rate."
};
